import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { IconButton } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as Yup from 'yup';

import Button from '../../components/Button';
import Input from '../../components/Input';
import { showError, showToast } from '../../constants/toasts';
import { usePostForgotPasswordMutation } from '../../service/auth';
import { CommonBody } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';

import AuthLayout from './AuthLayout';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [forgetPasswordMutation] = usePostForgotPasswordMutation();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required('Email is required')
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          'Please enter a valid email address'
        ),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);

      const body = {
        email: values.email,
      };

      try {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await forgetPasswordMutation(encryptedBody).unwrap();
        if (response?.statusCode === 200) {
          navigate('/verify-otp', { state: { email: formik.values.email } });
          showToast('OTP sent successfully');
        }
      } catch (error: any) {
        showError(error?.data?.message || '');
        console.error(error);
      }
    },
  });

  return (
    <AuthLayout>
      <div className="authBox">
        <div>
          <IconButton
            className="back-btn"
            onClick={() => navigate(-1)} // Navigate back
            sx={{
              // display: "flex",
              // alignItems: "center",
              // gap: "8px",
              // background: "transparent",
              // color: "#000",
              // fontSize: "16px",
              position: 'absolute',
              color: '#000',
              fontSize: '16px',
              background: 'transparent',
            }}
          >
            <KeyboardBackspaceIcon />
          </IconButton>
          <h2>Forgot Password</h2>
        </div>
        <p>Enter your email to reset your password.</p>
        <form onSubmit={formik.handleSubmit}>
          <Input
            placeholder="Email"
            name="email"
            id="email"
            inputProps={{ maxLength: 80 }}
            value={formik.values.email}
            onChange={(val) => {
              if (val.target.value === ' ' || val.target.value === '.') {
              } else {
                formik.handleChange(val);
              }
            }}
            onBlur={formik.handleBlur}
            helperText={formik.touched.email && formik.errors.email}
          />

          <Button value="Submit" type="submit" />
        </form>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
